import { createSlice } from "@reduxjs/toolkit"

const INITIAL_STATE = {
  loaded: false,
  tokenCosts: {
    CV_ANALYSIS: 1,
    JOB_ANALYSIS: 2,
    JOB_MATCHING: 3
  },
  freemiumPlan: {
    NAME: "Freemium Plan",
    TOKENS: 150,
    CV_LIMIT: 150
  }
};

const configSlice = createSlice({
  name: "credit",
  initialState: INITIAL_STATE,
  reducers: {
    setAppConfig: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key]
      })
      state.loaded = true
    },
    resetConfigSlice: (state) => {
      Object.keys(INITIAL_STATE).forEach((key) => {
        state = INITIAL_STATE[key]
      })
    },
  },
})

export const { setAppConfig, resetConfigSlice } = configSlice.actions
export default configSlice.reducer
